/**
 * @Description 拓店任务详情-开发经理选择
 */

import { FC, useEffect, useState, } from 'react';

import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { employeeListPermission } from '@/common/api/employee';
import { isArray } from '@lhb/func';

const FormManager:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
}) => {
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getSelection();
  }, []);

  const getSelection = async () => {
    const { objectList: data } = await employeeListPermission({});
    const arr = isArray(data) && data.length ? data.map((item) => ({
      label: `${item.name} ${item.mobile}`,
      value: item.id
    })) : [];
    setOptions(arr);
  };

  return (
    <V2FormSelect
      required={required}
      name={name}
      label={label}
      options={options}
      rules={rules}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig
      }}
      formItemConfig={formConfig}
    />
  );
};

export default FormManager;
